import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const SupplierOrdersSlice = createSlice({
    name: "supplierOrdersSlice",
    initialState,
    reducers: {
        supplierOrdersRequest(state) {
            state.loading = true;
        },
        supplierOrdersRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        supplierOrdersRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    supplierOrdersRequest,
    supplierOrdersRequestSuccess,
    supplierOrdersRequestError,
} = SupplierOrdersSlice.actions;

export default SupplierOrdersSlice.reducer;
